import BuySellPricesForManual from './BuySellPricesForManual';

export default BuySellPricesForManual;
